import { render, staticRenderFns } from "./SearchAndSelect.vue?vue&type=template&id=4bff13fc"
import script from "./SearchAndSelect.vue?vue&type=script&lang=js"
export * from "./SearchAndSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports